import React, { useState } from 'react';
import { Modal } from '../components/design-system/Modal';
import { ContentWrapper } from '../components/design-system/ContentWrapper';
import { ProductName } from '../components/ProductName';

const AppSplashPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [wantsBeta, setWantsBeta] = useState(true);
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setHasAttemptedSubmit(true);
    
    // Validate email before submission
    if (!email.trim()) {
      setEmailError('Email is required');
      return;
    }
    
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    
    // Clear any previous errors
    setEmailError('');
    
    // Handle form submission logic here
    console.log('Submitted email:', email);
    console.log('Wants beta access:', wantsBeta);

    fetch('https://smart-wallet-feedback-service.fly.dev/addEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, wantsBeta }),
    })
      .then((response) => {
        console.log('Response:', response);
        setIsSubmitSuccessful(true);
        setEmail(''); // Clear the form
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    
    // Only validate if user has attempted to submit once
    if (hasAttemptedSubmit) {
      if (!newEmail.trim()) {
        setEmailError('Email is required');
      } else if (!validateEmail(newEmail)) {
        setEmailError('Please enter a valid email address');
      } else {
        setEmailError('');
      }
    }
  };

  return (
    <div>
      <ContentWrapper>
        <a
          href="/"
          style={{
            textDecoration: 'none',
            marginBottom: '3rem',
            maxWidth: '1000px',
            margin: '0 auto',
          }}
        >
          <ProductName />
        </a>
        <div
          style={{
            maxWidth: '1000px',
            margin: '3rem auto',
            textAlign: 'center',
          }}
        >
          <div style={{ maxWidth: '800px', margin: '3rem auto' }}>
            <h2
              style={{
                fontSize: '3rem',
                color: '#000',
                lineHeight: 1.3,
                fontWeight: 'lighter',
                fontFamily: 'Merriweather',
              }}
            >
              Autopilot for credit card rewards.
              <br />
              <span
                style={{
                  backgroundImage: 'url("/highlights/h1-highlight.svg")',
                  backgroundSize: '110% 110%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  padding: '10px 20px ',
                  display: 'inline-block',
                }}
              >
                No thinking required.
              </span>
            </h2>
          </div>

          {/* Waitlist form */}
          <div style={{ maxWidth: '600px', margin: '2rem auto' }}>
            <p
              style={{
                fontSize: '1.25rem',
                marginBottom: '1rem',
                color: '#000',
                fontFamily: 'Merriweather',
              }}
            >
              Get notified when we launch
            </p>
            <form onSubmit={handleSubmit}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '0.5rem',
                }}
              >
                <input
                  type="checkbox"
                  name="wantsBeta"
                  id="wantsBeta"
                  style={{
                    marginRight: '4px',
                  }}
                  checked={wantsBeta}
                  onChange={(e) => setWantsBeta(e.target.checked)}
                />
                <label
                  htmlFor="wantsBeta"
                  style={
                    {
                      color: '#000',
                      fontSize: '0.875rem',
                      fontFamily: 'Merriweather',
                    }
                  }
                >
                  Send me beta access
                </label>
              </div>

              <div style={{ display: 'flex', position: 'relative' }}>
                <input
                  style={{
                    flex: 1,
                    padding: '0.875rem 1.5rem',
                    fontSize: '1.125rem',
                    borderRadius: '9999px',
                    border: `2px solid ${
                      hasAttemptedSubmit && emailError ? '#ff3b30' : '#000'
                    }`,
                    fontFamily: 'Merriweather',
                    backgroundColor: '#fff',
                    width: '100%',
                  }}
                  placeholder="you@example.com"
                  value={email}
                  onChange={handleEmailChange}
                />
                <button
                  type="submit"
                  style={{
                    position: 'absolute',
                    color: '#000',
                    fontWeight: 'lighter',
                    borderRadius: '9999px',
                    right: '4px',
                    top: '4px',
                    bottom: '4px',
                    border: 'none',
                    cursor: 'pointer',
                    backgroundImage: 'url("/highlights/button-highlight.svg")',
                    backgroundSize: '100% 200%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    fontFamily: 'Merriweather',
                    padding: '0 20px',
                    height: 'calc(100% - 8px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'visible',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'border-box',
                  }}
                >
                  submit
                </button>
              </div>
              {hasAttemptedSubmit && emailError && (
                <p
                  style={{
                    color: '#ff3b30',
                    fontSize: '0.875rem',
                    marginTop: '0.5rem',
                    fontFamily: 'Merriweather',
                  }}
                >
                  {emailError}
                </p>
              )}
              {isSubmitSuccessful && (
                <p
                  style={{
                    color: '#4CAF50',
                    fontSize: '0.875rem',
                    marginTop: '0.5rem',
                    fontFamily: 'Merriweather',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span style={{ marginRight: '0.5rem' }}>✅</span>
                  Thanks! We'll notify you when we launch.
                </p>
              )}
            </form>
            <p
              style={{
                fontSize: '0.875rem',
                color: '#86A1B3',
                marginTop: '0.5rem',
                fontFamily: 'Merriweather',
              }}
            >
              By submitting your email, you agree to our{' '}
              <button
                style={{
                  background: 'none',
                  fontSize: '0.875rem',
                  color: '#86A1B3',
                  textDecoration: 'underline',
                  fontWeight: 'regular',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  fontFamily: 'Merriweather',
                }}
                onClick={() => setIsModalOpen(true)}
              >
                Privacy Policy
              </button>
            </p>
          </div>

          {/* App features with images */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '2rem',
              flexDirection: 'row', // Default to row layout
              flexWrap: 'wrap', // Allow wrapping on smaller screens
            }}
            className="app-features-container"
          >
            <img
              src="/app-feature-left.png"
              alt="SuperWallet app features"
              style={{
                width: '56%',
                marginRight: '-5%',
                borderRadius: '2rem',
                objectFit: 'contain',
                height: 'auto',
              }}
              className="app-feature-image"
            />
            <img
              src="/app-feature-right.png"
              alt="SuperWallet app features"
              style={{
                zIndex: -1,
                marginTop: '50px',
                width: '56%',
                marginLeft: '-5%',
                marginRight: '-2%',
                borderRadius: '2rem',
                objectFit: 'contain',
                height: 'auto',
              }}
              className="app-feature-image"
            />
          </div>
        </div>
      </ContentWrapper>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isModalOpen} handleClose={() => setIsModalOpen(false)}>
        <h3
          style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
          }}
        >
          Privacy Policy
        </h3>
        <p style={{ marginBottom: '1rem' }}>
          This Privacy Policy describes how SuperWallet collects, uses, and
          discloses your personal information when you use our application and
          services.
        </p>
        <p style={{ marginBottom: '1rem' }}>
          We collect information you provide directly to us, such as when you
          create an account, update your profile, use interactive features,
          participate in contests, promotions, or surveys, request customer
          support or otherwise communicate with us.
        </p>
        <p style={{ marginBottom: '1rem' }}>
          We may use the information we collect to provide, maintain, and
          improve our services, develop new products and services, communicate
          with you, and personalize your experience.
        </p>
        <p style={{ marginBottom: '1rem' }}>
          We may share your information with third-party vendors and service
          providers who perform services on our behalf, such as payment
          processing, data analysis, email delivery, hosting services, and
          customer service.
        </p>
      </Modal>

      <p
        style={{
          textAlign: 'center',
          fontSize: '0.875rem',
          color: '#86A1B3',
          fontFamily: 'Merriweather',
        }}
      >
        This app is not affiliated with, endorsed by, or sponsored by Apple
        Inc., Apple Wallet, or iOS Shortcuts
      </p>

      {/* Add this style tag before the closing PageWrapper */}
      <style>
        {`
          input::placeholder {
            color: #86A1B3;
            font-family: 'Merriweather';
          }
          button:hover {
            background-color: inherit;
          }
          
          /* Media query for mobile devices */
          @media (max-width: 768px) {
            .app-features-container {
              flex-direction: column !important;
              align-items: center;
            }
            
            .app-feature-image {
              width: 90% !important;
              margin: 1rem auto !important;
              z-index: 0 !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AppSplashPage;

